import { useSidebarState } from 'react-admin';
import SubMenuFlyout from './SubMenuFlyout';
import SubMenuInline from './SubMenuInline';
import { SubMenuProps } from './types';

/**
 * Grupo do menu lateral, em duas formas.
 *
 * Com a barra ABERTA é um acordeão. A hierarquia é carregada por três coisas,
 * porque só indentar não bastava — aberto, header e filhos ficavam idênticos e
 * não dava para saber onde um grupo começava e o outro terminava: o header
 * mantém o ícone, o chevron vai para a direita e gira, e os filhos ficam presos
 * a um trilho vertical.
 *
 * Com a barra RECOLHIDA o acordeão não cabe: a coluna tem ~55px, os filhos
 * viravam uma pilha de ícones com o rótulo cortado na primeira letra,
 * indistinguíveis dos itens de primeiro nível. Nesse caso o grupo abre um
 * painel flutuante ao lado do ícone (`SubMenuFlyout`).
 *
 * Submenu ANINHADO dentro de um painel não vira acordeão: abre o painel dele AO
 * LADO, em cascata, como o menu do macOS. Quem decide isso é o próprio
 * `SubMenuFlyout`, pelo `SubMenuFlyoutContext`.
 */
const SubMenu = (props: SubMenuProps) => {
    const [sidebarIsOpen] = useSidebarState();

    return sidebarIsOpen ? <SubMenuInline {...props} /> : <SubMenuFlyout {...props} />;
};

export default SubMenu;
export type { SubMenuProps };
